module.exports = __webpack_public_path__ + "img/3.ba9e1ad3.png";